import React from 'react';
import { CostCalculator } from './src/components/CostCalculator';
export function App() {
  return <div className="min-h-screen w-full bg-white text-slate-900 font-['Inter']" data-id="element-0">
      <CostCalculator data-id="element-1" />
    </div>;
}